import { render, staticRenderFns } from "./CategoryComponent.vue?vue&type=template&id=4c92a0f7&scoped=true&"
import script from "./CategoryComponent.vue?vue&type=script&lang=js&"
export * from "./CategoryComponent.vue?vue&type=script&lang=js&"
import style0 from "./CategoryComponent.vue?vue&type=style&index=0&id=4c92a0f7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c92a0f7",
  null
  
)

export default component.exports